import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Location } from '@reach/router';
import Layout from '../components/layout';
import Metadata from '../components/metadata/metadata';
import PageState from '../contexts/page';
import contentfulRichTextRender from '../contentful/richtext-renderer';
import Banner from '../components/announcement-banner';
/* Remove message
import MessageBanner from '../components/message-banner';

const HomeMessage = (
  <MessageBanner>
  As part of the transition to Google Workspace, all CME Group branded templates are now available in both Google and Microsoft formats.
  </MessageBanner>
);
const TemplateMessage = (
  <MessageBanner>
  As part of the transition to Google Workspace, all CME Group branded templates are now available in both Google and Microsoft formats.
  </MessageBanner>
);
*/

const JsonPageTemplate = ({
  content, pageId, pagePath, parentId, seoDescription, socialImage, title, bannerAnnouncement,
}) => {
  const hasContent = (content && content.content && content.content.length > 0);
  // insert message into content on Home and Template Chooser pages
  let firstContent = null;
  let message = null;
  let originalContent = null;
  // backup of original content array
  if (hasContent) {
    originalContent = content.content.slice();
    // potentially modified array
    let remainingContent = content.content.slice();

    // remove message
    /* if (pagePath === '/') {
      firstContent = remainingContent.shift();
      message = HomeMessage;
    } else if (pagePath === '/templates/template-chooser/') {
      firstContent = remainingContent.shift();
      message = TemplateMessage;
    } */

    // use cloned and modified array
    content.content = remainingContent;
  }

  const output = (
    <PageState pageId={pageId} pagePath={pagePath} parentId={parentId} bannerAnnouncement={bannerAnnouncement ? bannerAnnouncement.json : null}>
    <Banner>
      {bannerAnnouncement && contentfulRichTextRender(bannerAnnouncement)}
    </Banner>
      <Layout>
        <Metadata
          title={title}
          description={seoDescription}
          image={socialImage}
        />
        {firstContent && contentfulRichTextRender(firstContent)}
        {message}
        {content && contentfulRichTextRender(content)}
      </Layout>
    </PageState>
  );

  if (hasContent) {
    // revert content array to original
    content.content = originalContent;
  }
  
  return output;
};

JsonPageTemplate.propTypes = {
  pageId: PropTypes.string.isRequired,
  pagePath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  parentId: PropTypes.string,
  content: PropTypes.object,
  bannerAnnouncement: PropTypes.object,
  seoDescription: PropTypes.string,
  socialImage: PropTypes.object,
};

JsonPageTemplate.defaultProps = {
  parentId: '',
  content: null,
  bannerAnnouncement: null,
  seoDescription: '',
  socialImage: null,
};

const JsonPage = ({ data, pagePath }) => {
  const { page, parent } = data;
  const {
    contentful_id: pageId, content, seoDescription, socialImage, title,bannerAnnouncement,
  } = page;
  const { contentful_id: parentId } = parent || {};

  return (
    <JsonPageTemplate
      pageId={pageId}
      pagePath={pagePath}
      parentId={parentId}
      content={content ? content.json : null}
      bannerAnnouncement={bannerAnnouncement ? bannerAnnouncement.json : null}
      seoDescription={seoDescription ? seoDescription.seoDescription : null}
      socialImage={socialImage}
      title={title}
    />
  );
};
JsonPage.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.shape({
      content: PropTypes.shape({
        json: PropTypes.object.isRequired,
      }).isRequired,
      bannerAnnouncement: PropTypes.shape({
        json: PropTypes.object.isRequired,
      }).isRequired,
      contentful_id: PropTypes.string.isRequired,
      seoDescription: PropTypes.shape({
        seoDescription: PropTypes.string.isRequired,
      }),
      socialImage: PropTypes.object,
      title: PropTypes.string.isRequired,
    }).isRequired,
    parent: PropTypes.shape({
      contentful_id: PropTypes.string.isRequired,
    }),
  }).isRequired,
  pagePath: PropTypes.string.isRequired,
};

const JsonPageWithLocation = (props) => (
  <Location>
    {({ location }) => (
      <JsonPage
        pagePath={location.pathname}
        {...props}
      />
    )}
  </Location>
);

export default JsonPageWithLocation;

export const query = graphql`
  query($language: String!, $pageId: String!, $parentId: String) {
    page: contentfulPage(node_locale: { eq: $language }, contentful_id: {eq: $pageId}) {
      contentful_id
      title
      content {
        json
      }
      bannerAnnouncement {
        json
      }
      seoDescription {
        seoDescription
      }
      socialImage {
        fixed(width: 1200) {
          ...GatsbyContentfulFixed
        }
      }
    }
    parent: contentfulPage(node_locale: { eq: $language }, contentful_id: {eq: $parentId}) {
      contentful_id
    }
  }
`;
